import styled from 'styled-components';

export const Layout = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--spacing-large);
  align-items: start;

  @media (width < 48rem) {
    grid-template-columns: 1fr;
  }
`;

export const DetailsColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-base);
`;

export const MapColumn = styled.div`
  min-height: 600px;
  border-radius: var(--radius-large);
  overflow: hidden;

  @media (width < 48rem) {
    min-height: 400px;
  }
`;

export const MapContainer = styled.div`
  width: 100%;
  height: 100%;
  min-height: inherit;
`;

export const Dropdown = styled.select`
  width: 100%;
  margin-bottom: var(--spacing-large);
  padding: var(--spacing-small) var(--spacing-base);
  border: 1px solid var(--grey-300);
  border-radius: var(--radius-large);
  box-shadow: var(--shadow-xs);
  font-size: var(--font-size-text-md);
  font-weight: var(--font-weight-regular);
  line-height: 24px;
  color: var(--black);
  background: var(--white);
  outline: none;
  cursor: pointer;

  &:focus {
    border-color: var(--brand-600);
    box-shadow: var(--shadow-focus);
  }
`;

export const DetailsPanel = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-base);
`;

export const StoreName = styled.h2`
  margin: 0;
  color: var(--black);
`;

export const AddressBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-xsmall);
  color: var(--grey-700);
  font-size: var(--font-size-text-md);
`;

export const DetailRow = styled.div`
  display: grid;
  grid-template-columns: 140px 1fr;
  gap: var(--spacing-small);
  font-size: var(--font-size-text-sm);
  line-height: 24px;
`;

export const DetailLabel = styled.span`
  font-weight: var(--font-weight-bold);
  color: var(--black);
`;

export const DetailValue = styled.span`
  color: var(--grey-700);
`;

export const SectionHeading = styled.h3`
  margin: var(--spacing-small) 0 0;
  color: var(--black);
`;
